export enum FeedbackTrendTypes{
    Upwards = 'Upwards',
    Downwards = 'Downwards',
    NoChange = 'No Change'
}